import { Directive, TemplateRef } from '@angular/core';

import { PmdTab } from './tab.directive';

/** Should be used to mark <ng-template> element as a template for tab heading */
@Directive({ 
  selector: '[pmd-tab-label]',
  exportAs: 'pmdTabLabel'
})

export class PmdTabLabel {
  templateRef: TemplateRef<any>;
  constructor(templateRef: TemplateRef<any>, tab: PmdTab) {
    tab.headingRef = templateRef;
  }
}